import { render, staticRenderFns } from "./Canban.vue?vue&type=template&id=f742b15c&"
import script from "./Canban.vue?vue&type=script&lang=js&"
export * from "./Canban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports